import { useState } from 'react';

function useFacilitar() {
  const [facilitar] = useState(window.location.origin.includes('facilitar'));
  window.document.title = facilitar ? 'Facilitar Gestão' : 'Elevar Gestão';
  return facilitar;
}

export default useFacilitar;
